import { useContext } from "react"

import Radio from "../form/Radio/Radio"
import MinAndStandardLabelContext from "./MinAndStandardLabelContext"

type Props = {
  value: string
} & JSX.IntrinsicElements["input"]

const MinAndStandardLabelRadio = ({ children, value }: Props) => {
  const { minId, standardId } = useContext(MinAndStandardLabelContext)
  const label = minId === value ? "［最小］" : standardId === value ? "［標準］" : null

  return (
    <Radio value={value}>
      {children}
      {label && "\n"}
      {label}
    </Radio>
  )
}

export default MinAndStandardLabelRadio
